import React, { useState, useEffect } from 'react';
import { Container, Box } from '@mui/material';
import IAEditor from '../IAEditor';
import IADraftList from '../IADraftList';
import { categoryService } from '../../api/services';

export default function IAEditorSection() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    categoryService.getCategories().then(res => setCategories(res.data));
  }, []);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <IAEditor categories={categories} />
      <Box sx={{ mt: 4 }}>
        <IADraftList />
      </Box>
    </Container>
  );
}